export default __webpack_public_path__ + "static/media/resting.6db91488.svg";